import { type TableHTMLAttributes, useLayoutEffect, useRef } from "react";

function getColumnLabels(table: HTMLTableElement): string[] {
  const headerRow = table.tHead?.rows[0];
  if (!headerRow) return [];

  return Array.from(headerRow.cells).map((th) => {
    const sortLabel = th.querySelector(".tbl-sort > span:first-of-type");
    if (sortLabel?.textContent) return sortLabel.textContent.trim();
    return (th.textContent ?? "").replace(/\s*[↕↑↓]\s*/g, "").trim();
  });
}

export function applyResponsiveTableLabels(table: HTMLTableElement): void {
  const labels = getColumnLabels(table);

  for (const body of table.tBodies) {
    for (const row of body.rows) {
      if (row.classList.contains("tbl__group-row")) continue;

      for (let index = 0; index < row.cells.length; index++) {
        const cell = row.cells[index]!;
        if (cell.colSpan > 1) {
          cell.removeAttribute("data-label");
        } else {
          cell.setAttribute("data-label", labels[index] ?? "");
        }
      }
    }
  }
}

export function ResponsiveTable({
  className,
  children,
  ...props
}: TableHTMLAttributes<HTMLTableElement>) {
  const ref = useRef<HTMLTableElement>(null);

  useLayoutEffect(() => {
    if (ref.current) applyResponsiveTableLabels(ref.current);
  });

  return (
    <table ref={ref} className={className} {...props}>
      {children}
    </table>
  );
}
